module.exports = __webpack_public_path__ + "img/help-ot8.e26b6168.png";